<template>
  <div>
    <div class="columns is-mobile is-multiline is-centered has-text-centered">
      <div class="column is-3-desktop is-6-mobile">
        <p class="heading">Practiced</p>
        <p class="is-size-4">{{ totalPractice }} days</p>
      </div>
      <div class="column is-3-desktop is-6-mobile">
        <p class="heading">Skipped</p>
        <p class="is-size-4">{{ totalSkipped }} days</p>
      </div>
      <div class="column is-3-desktop is-6-mobile">
        <p class="heading">Max Streak</p>
        <p class="is-size-4">{{ maxStreak }} days</p>
      </div>
      <div class="column is-3-desktop is-6-mobile">
        <p class="heading">Max Gap</p>
        <p class="is-size-4">{{ maxGap }} days</p>
      </div>
    </div>
    <p class="is-size-7">
      <b>Streak</b> - number of consecutive days in which you have practiced;
      <b>Gap</b> - number of consecutive days in which you have not practiced;
    </p>
  </div>
</template>

<script>
export default {
  props: ["totalPractice", "totalSkipped", "maxStreak", "maxGap"]
};
</script>

<style lang="scss" scoped></style>
